import { MatchTrackBase } from "model/Match/Track/MatchTrack";
import { TimeAttackRound } from "./Round/TimeAttackRound";
import { TimeAttackScoring } from "./Scoring/TimeAttackScoring";
import { isTimeAttackScoringSum } from "./Scoring/TimeAttackScoringSum";
import { isTimeAttackScoringAverage } from "./Scoring/TimeAttackScoringAverage";
import { Scores } from "model/Scores";
import { Positions } from "model/Positions";

export type TimeAttackTrack = MatchTrackBase & {
  finalPositions: Positions | undefined;
  rounds: TimeAttackRound[];
  scores: Scores;
};

export const getTimeAttackTrackWeightHeaders = (
  track: TimeAttackTrack,
  scoring: TimeAttackScoring,
  asPercentage: boolean = true
): (string | undefined)[] | undefined => {
  if (isTimeAttackScoringSum(scoring)) {
    return Array(track.rounds.length).fill(undefined);
  }

  if (isTimeAttackScoringAverage(scoring)) {
    return scoring.roundWeightings.flatMap((w) =>
      w.weightings.map((w) => `${w}${asPercentage ? "%" : ""}`)
    );
  }
};
